export default "__VITE_ASSET__Bxj6w4Ov__"